// Multilingual dictionary: IT, DE, FR removed (per user request: PT, DE, IT, ES, EN)
export const LANGS = [
  { code: "it", label: "IT", name: "Italiano" },
  { code: "de", label: "DE", name: "Deutsch" },
  { code: "en", label: "EN", name: "English" },
  { code: "es", label: "ES", name: "Español" },
  { code: "pt", label: "PT", name: "Português" },
];

const dict = {
  it: {
    app_name: "Swiss Wealth CRM",
    tagline: "Vermögensberatung, Schweizer Präzision.",
    login: "Accedi",
    logout: "Esci",
    email: "Email",
    password: "Password",
    sign_in: "Entra",
    dashboard: "Dashboard",
    clients: "Kunden",
    calendar: "Kalender",
    notifications: "Benachrichtigungen",
    settings: "Einstellungen",
    add_client: "Neu Kunde",
    add_client_ai: "Neu Kunde con IA",
    search_clients: "Suchen clienti…",
    no_clients: "Kein cliente. Hinzufügen il primo.",
    first_name: "Vorname",
    last_name: "Nachname",
    date_of_birth: "Data di nascita",
    place_of_birth: "Luogo di nascita",
    nationality: "Nazionalità",
    document_number: "N° Dokument",
    permit_type: "Dokumenttyp/permesso",
    address: "Adresse",
    city: "Stadt",
    postal_code: "CAP",
    canton: "Kanton",
    country: "Land",
    phone: "Telefon",
    notes: "Note",
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    edit: "Bearbeiten",
    upload: "Hochladen",
    upload_doc: "Hochladen documento",
    upload_policy: "Hochladen Police/Vertrag",
    ai_extract: "Estrai con IA",
    ai_provider: "Modello IA",
    documents: "Dokumente",
    policies: "Policen",
    insurances: "Versicherungen",
    insurance_status: "Status assicurazioni",
    expiring_soon: "In scadenza (60gg)",
    total_clients: "Kunden totali",
    total_policies: "Policen totali",
    unread_notifs: "Benachrichtigungen da leggere",
    company: "Gesellschaft",
    policy_number: "N° Police",
    start_date: "Data inizio",
    end_date: "Data scadenza",
    premium: "Prämie",
    currency: "Valuta",
    insurance_type: "Typ",
    new_policy: "Neu Police",
    drop_here: "Trascina o clicca per caricare",
    processing_ai: "L'IA sta analizzando il documento…",
    extraction_done: "Extraktion abgeschlossen",
    fill_review: "Rivedi e modifica i dati estratti",
    mark_all_read: "Segna tutte lette",
    no_notifications: "Keine notifica",
    policy_expires_in: "Scade in",
    days: "giorni",
    profile: "Profil",
    personal_docs: "Dokumente personali",
    has_insurance: "Versichert",
    no_insurance: "Non assicurato",
    welcome_back: "Willkommen zurück",
    language: "Sprache",
    services: "Dienste",
    companies: "Gesellschaften",
    financial_analysis: "Finanzanalyse",
    new_analysis: "Neu Analyse",
    generate_pdf: "Erstellen PDF",
    ai_prefill: "Pre-compila con IA",
    fa_open: "Öffnen Finanzanalyse",
    users: "Benutzer",
    pillar_trust: "FIDUCIA",
    pillar_competence: "COMPETENZA",
    pillar_independence: "INDIPENDENZA",
    pillar_security: "SICUREZZA",
    consultant: "Berater",
    role: "Rolle",
    admin: "Admin",
    assign: "Assegna",
    assigned_to: "Assegnato a",
    unassigned: "Non assegnato",
    create_user: "Erstellen utente",
    sign: "Unterschrift",
    signature: "Unterschrift",
    clear_signature: "Löschen firma",
    advisor1: "Berater FINMA",
    advisor2: "Berater ohne FINMA",
    client_confirmation: "Kundenbestätigung",
    form_tandem: "Tandem-Modell",
    form_beratungsprotokoll: "Beratungsprotokoll",
    form_angemessenheitspruefung: "Angemessenheitsprüfung",
    form_kuendigung: "Kündigung KVG/VVG",
    form_maklervollmacht: "Maklervollmacht",
    new_form: "Neu formulario",
    select_client: "Auswählen cliente",
    select_form_type: "Formulartyp",
    send_to_company: "Dokumente senden",
    no_companies: "Keine compagnia",
    add_company: "Hinzufügen compagnia",
    months: ["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],
    weekdays_short: ["Lun","Mar","Mer","Gio","Ven","Sab","Dom"],
    today: "Heute",
    select_provider: "Auswählen modello",
    select_doc_type: "Auswählen tipo documento",
    confirm_delete: "Löschung bestätigen?",
    yes_delete: "Ja, löschen",
    select_client_first: "Auswählen prima un cliente",
    insurance_types: {
      casa: "Casa", auto: "Auto", rc: "RC", tutela_legale: "Tutela legale",
      malattia: "Malattia", viaggi: "Viaggi", negozio: "Negozio",
      vita_3a: "Vita 3A", vita_3b: "Vita 3B", hypothek: "Ipoteca", mietkaution: "Cauzione affitto",
    },
    personal_types: {
      profile_photo: "Foto profilo",
      carta_identita: "Identitätskarte (Vorderseite)", carta_identita_retro: "Identitätskarte (Rückseite)",
      patente: "Führerausweis",
      permesso: "Bewilligung", passaporto: "Reisepass",
      tandem_formular: "Tandem-Modell", beratungsprotokoll: "Beratungsprotokoll",
      angemessenheitspruefung: "Angemessenheitsprüfung", kuendigung: "Kündigung",
      maklervollmacht: "Maklervollmacht",
      mandato_servizio: "Dienstmandat", mandato_gestione: "Verwaltungsmandat",
      analisi_finanziaria: "Finanzanalyse",
    },
    // Client detail UI
    Stammdaten: "Stammdaten",
    personal_data: "Dati personali",
    contacts: "Contatti",
    family: "Familie",
    private_notes: "Note private",
    add: "Hinzufügen",
    gender: "Geschlecht",
    religion: "Religion",
    civil_status: "Status civile",
    civil_status_celibe: "Celibe / Nubile",
    civil_status_sposato: "Sposato/a",
    civil_status_separato: "Separato/a",
    civil_status_divorziato: "Divorziato/a",
    civil_status_vedovo: "Vedovo/a",
    civil_status_orfano: "Orfano/a",
    gender_M: "Männlich", gender_F: "Weiblich", gender_X: "Andere",
    religion_cattolica: "Katholisch",
    religion_protestante: "Protestantisch / Evangelica",
    religion_ortodossa: "Orthodox",
    religion_ebraica: "Jüdisch",
    religion_musulmana: "Muslimisch",
    religion_buddista: "Buddhistisch",
    religion_induista: "Hinduistisch",
    religion_atea: "Konfessionslos / Keine",
    religion_altro: "Andere",
    street_no: "Strasse / N°",
    coverage_barometer: "Barometro di copertura",
    coverage_high_risk: "Rischio alto",
    coverage_partial: "Parziale",
    coverage_covered: "Coperto",
    coverage_complete_label: "Copertura completa",
    coverage_good_label: "Buona copertura",
    coverage_partial_label: "Copertura parziale",
    coverage_low_label: "Copertura bassa",
    coverage_none_label: "Keine copertura",
    insurance_coverages: "Coperture assicurative",
    new_category: "Kategorie",
    no_family_member: "Kein familiare collegato",
    edit_btn: "Bearbeiten",
    relationship_coniuge: "Ehepartner",
    relationship_marito: "Ehemann",
    relationship_moglie: "Ehefrau",
    relationship_figlio: "Sohn",
    relationship_figlia: "Tochter",
    relationship_padre: "Vater",
    relationship_madre: "Mutter",
    relationship_fratello: "Bruder",
    relationship_sorella: "Schwester",
    // Sidebar nav
    nav_management: "Direktion",
    nav_genehmigtls: "Genehmigungen",
    nav_commissions: "Provisionen",
    nav_rates: "Tarife %",
    nav_finance: "Finanzen",
    tab_policies: "Policen",
    tab_client_docs: "Doc. Kunde",
    tab_company_docs: "Doc. Aziendale",
    tab_commissions: "Provisionen",
  },
  de: {
    app_name: "Swiss Wealth CRM",
    tagline: "Vermögensberatung, Schweizer Präzision.",
    login: "Anmelden", logout: "Abmelden", email: "E-Mail", password: "Passwort",
    sign_in: "Einloggen", dashboard: "Dashboard", clients: "Kunden",
    calendar: "Kalender", notifications: "Benachrichtigungen", settings: "Einstellungen",
    add_client: "Neuer Kunde", add_client_ai: "Neuer Kunde mit KI",
    search_clients: "Kunden suchen…", no_clients: "Keine Kunden.",
    first_name: "Vorname", last_name: "Nachname", date_of_birth: "Geburtsdatum",
    place_of_birth: "Geburtsort", nationality: "Nationalität", document_number: "Dok-Nr.",
    permit_type: "Bewilligung",
    address: "Adresse", city: "Stadt", postal_code: "PLZ", canton: "Kanton",
    country: "Land", phone: "Telefon", notes: "Notizen", save: "Speichern",
    cancel: "Abbrechen", delete: "Löschen", edit: "Bearbeiten", upload: "Hochladen",
    upload_doc: "Dokument hochladen", upload_policy: "Police/Vertrag hochladen",
    ai_extract: "Mit KI extrahieren", ai_provider: "KI-Modell",
    documents: "Dokumente", policies: "Verträge", insurances: "Versicherungen",
    insurance_status: "Versicherungsstatus", expiring_soon: "Bald ablaufend (60T)",
    total_clients: "Kunden gesamt", total_policies: "Verträge gesamt",
    unread_notifs: "Ungelesen", company: "Gesellschaft",
    policy_number: "Police-Nr.", start_date: "Startdatum", end_date: "Ablaufdatum",
    premium: "Prämie", currency: "Währung", insurance_type: "Typ",
    new_policy: "Neue Police", drop_here: "Datei ablegen oder klicken",
    processing_ai: "KI analysiert das Dokument…", extraction_done: "Extraktion abgeschlossen",
    fill_review: "Daten prüfen und anpassen", mark_all_read: "Alle als gelesen",
    no_notifications: "Keine Benachrichtigungen", policy_expires_in: "Läuft ab in",
    days: "Tagen", profile: "Profil", personal_docs: "Persönliche Dokumente",
    has_insurance: "Versichert", no_insurance: "Nicht versichert",
    welcome_back: "Willkommen zurück", language: "Sprache",
    services: "Dienste", companies: "Gesellschaften", users: "Benutzer",
    financial_analysis: "Finanzanalyse", new_analysis: "Neue Analyse", ai_prefill: "Mit KI vorausfüllen", fa_open: "Finanzanalyse öffnen",
    pillar_trust: "VERTRAUEN", pillar_competence: "KOMPETENZ",
    pillar_independence: "UNABHÄNGIGKEIT", pillar_security: "SICHERHEIT",
    consultant: "Berater", role: "Rolle", admin: "Admin",
    assign: "Zuweisen", assigned_to: "Zugewiesen an", unassigned: "Nicht zugewiesen",
    create_user: "Benutzer erstellen", generate_pdf: "PDF exportieren",
    sign: "Unterschreiben", signature: "Unterschrift", clear_signature: "Löschen",
    advisor1: "FINMA-Berater", advisor2: "Berater ohne FINMA",
    client_confirmation: "Kundenbestätigung",
    form_tandem: "Tandem-Modell", form_beratungsprotokoll: "Beratungsprotokoll",
    form_angemessenheitspruefung: "Angemessenheitsprüfung", form_kuendigung: "Kündigung KVG/VVG",
    form_maklervollmacht: "Maklervollmacht",
    new_form: "Neues Formular", select_client: "Kunde wählen",
    select_form_type: "Formulartyp", send_to_company: "Dokumente senden",
    no_companies: "Keine Gesellschaften", add_company: "Gesellschaft hinzufügen",
    months: ["Januar","Februar","März","April","Nie","Juni","Juli","August","September","Oktober","November","Dezember"],
    weekdays_short: ["Mo","Di","Mi","Do","Fr","Sa","So"],
    today: "Heute",
    select_provider: "Modell wählen", select_doc_type: "Dokumenttyp wählen",
    confirm_delete: "Wirklich löschen?", yes_delete: "Ja, löschen",
    select_client_first: "Erst Kunde wählen",
    insurance_types: {
      casa: "Haus", auto: "Auto", rc: "Haftpflicht", tutela_legale: "Rechtsschutz",
      malattia: "Kranken", viaggi: "Reise", negozio: "Geschäft",
      vita_3a: "Säule 3A", vita_3b: "Säule 3B", hypothek: "Hypothek", mietkaution: "Mietkaution",
    },
    personal_types: {
      profile_photo: "Profilfoto",
      carta_identita: "Identitätskarte (Vorderseite)", carta_identita_retro: "Identitätskarte (Rückseite)",
      patente: "Führerausweis",
      permesso: "Aufenthaltsbewilligung", passaporto: "Reisepass",
      tandem_formular: "Tandem-Modell", beratungsprotokoll: "Beratungsprotokoll",
      angemessenheitspruefung: "Angemessenheitsprüfung", kuendigung: "Kündigung",
      maklervollmacht: "Maklervollmacht",
      mandato_servizio: "Dienstmandat", mandato_gestione: "Verwaltungsmandat",
      analisi_finanziaria: "Finanzanalyse",
    },
    // Client detail UI
    Stammdaten: "Stammdaten",
    personal_data: "Persönliche Daten",
    contacts: "Kontakt",
    family: "Familie",
    private_notes: "Private Notizen",
    add: "Hinzufügen",
    gender: "Geschlecht",
    religion: "Religion",
    civil_status: "Zivilstand",
    civil_status_celibe: "Ledig",
    civil_status_sposato: "Verheiratet",
    civil_status_separato: "Getrennt",
    civil_status_divorziato: "Geschieden",
    civil_status_vedovo: "Verwitwet",
    civil_status_orfano: "Waise",
    gender_M: "Männlich", gender_F: "Weiblich", gender_X: "Andere",
    religion_cattolica: "Katholisch",
    religion_protestante: "Protestantisch / Evangelisch",
    religion_ortodossa: "Orthodox",
    religion_ebraica: "Jüdisch",
    religion_musulmana: "Muslimisch",
    religion_buddista: "Buddhistisch",
    religion_induista: "Hinduistisch",
    religion_atea: "Konfessionslos / Keine",
    religion_altro: "Andere",
    street_no: "Strasse / Nr.",
    coverage_barometer: "Versicherungsbarometer",
    coverage_high_risk: "Hohes Risiko",
    coverage_partial: "Teilweise",
    coverage_covered: "Versichert",
    coverage_complete_label: "Vollständige Deckung",
    coverage_good_label: "Gute Deckung",
    coverage_partial_label: "Teilweise Deckung",
    coverage_low_label: "Geringe Deckung",
    coverage_none_label: "Keine Deckung",
    insurance_coverages: "Versicherungsabdeckung",
    new_category: "Neue Kategorie",
    no_family_member: "Keine verbundenen Familienmitglieder",
    edit_btn: "Bearbeiten",
    relationship_coniuge: "Ehepartner",
    relationship_marito: "Ehemann",
    relationship_moglie: "Ehefrau",
    relationship_figlio: "Sohn",
    relationship_figlia: "Tochter",
    relationship_padre: "Vater",
    relationship_madre: "Mutter",
    relationship_fratello: "Bruder",
    relationship_sorella: "Schwester",
    // Sidebar nav
    nav_management: "Direktion",
    nav_genehmigtls: "Genehmigungen",
    nav_commissions: "Provisionen",
    nav_rates: "Tarife %",
    nav_finance: "Finanzen",
    tab_policies: "Policen",
    tab_client_docs: "Kundendoc.",
    tab_company_docs: "Gesellschaftsdoc.",
    tab_commissions: "Provisionen",
  },
  en: {
    app_name: "Swiss Wealth CRM",
    tagline: "Wealth advisory, Swiss precision.",
    login: "Login", logout: "Logout", email: "Email", password: "Password",
    sign_in: "Sign in", dashboard: "Dashboard", clients: "Clients",
    calendar: "Calendar", notifications: "Notifications", settings: "Settings",
    add_client: "New Client", add_client_ai: "New Client with AI",
    search_clients: "Search clients…", no_clients: "Nein clients yet.",
    first_name: "First name", last_name: "Last name", date_of_birth: "Date of birth",
    place_of_birth: "Place of birth", nationality: "Nationality",
    document_number: "Doc. Number", address: "Address", city: "City",
    permit_type: "Document/Permit type",
    postal_code: "ZIP", canton: "Canton", country: "Country", phone: "Phone",
    notes: "Notes", save: "Save", cancel: "Cancel", delete: "Delete",
    edit: "Edit", upload: "Upload", upload_doc: "Upload document",
    upload_policy: "Upload Policy/Contract", ai_extract: "Extract with AI",
    ai_provider: "AI model", documents: "Documents", policies: "Policies",
    insurances: "Insurances", insurance_status: "Insurance status",
    expiring_soon: "Expiring (60d)", total_clients: "Total clients",
    total_policies: "Total policies", unread_notifs: "Unread",
    company: "Company", policy_number: "Policy #", start_date: "Start date",
    end_date: "End date", premium: "Premium", currency: "Currency",
    insurance_type: "Type", new_policy: "New Policy",
    drop_here: "Drop file or click", processing_ai: "AI is analyzing…",
    extraction_done: "Extraction complete", fill_review: "Review extracted data",
    mark_all_read: "Mark all read", no_notifications: "Nein notifications",
    policy_expires_in: "Expires in", days: "days", profile: "Profile",
    personal_docs: "Personal documents", has_insurance: "Insured",
    no_insurance: "Not insured", welcome_back: "Welcome back",
    language: "Language", select_provider: "Select model",
    services: "Services", companies: "Companies", users: "Users",
    financial_analysis: "Financial Analysis", new_analysis: "New Analysis", ai_prefill: "AI prefill", fa_open: "Open Financial Analysis",
    pillar_trust: "TRUST", pillar_competence: "EXPERTISE",
    pillar_independence: "INDEPENDENCE", pillar_security: "SECURITY",
    consultant: "Consultant", role: "Role", admin: "Admin",
    assign: "Assign", assigned_to: "Assigned to", unassigned: "Unassigned",
    create_user: "Erstellt user", generate_pdf: "Export PDF",
    sign: "Sign", signature: "Signature", clear_signature: "Clear",
    advisor1: "FINMA Advisor", advisor2: "Non-FINMA Advisor",
    client_confirmation: "Client confirmation",
    form_tandem: "Tandem Model", form_beratungsprotokoll: "Advisory Record",
    form_angemessenheitspruefung: "Suitability Check", form_kuendigung: "Cancellation KVG/VVG",
    new_form: "New form", select_client: "Select client",
    select_form_type: "Form type", send_to_company: "Send documents",
    no_companies: "Nein companies", add_company: "Add company",
    select_doc_type: "Select doc type", confirm_delete: "Confirm delete?",
    yes_delete: "Yes, delete", select_client_first: "Select a client first",
    insurance_types: {
      casa: "Home", auto: "Car", rc: "Liability", tutela_legale: "Legal",
      malattia: "Health", viaggi: "Travel", negozio: "Shop",
      vita_3a: "Pillar 3A", vita_3b: "Pillar 3B", hypothek: "Mortgage", mietkaution: "Rent deposit",
    },
    personal_types: {
      profile_photo: "Profile photo",
      carta_identita: "ID Card (Front)", carta_identita_retro: "ID Card (Back)", patente: "Driver Lic.",
      permesso: "Permit", passaporto: "Passport",
      tandem_formular: "Tandem Model", beratungsprotokoll: "Advisory record",
      angemessenheitspruefung: "Suitability Check", kuendigung: "Cancellation",
      analisi_finanziaria: "Financial analysis",
    },
  },
  es: {
    app_name: "Swiss Wealth CRM",
    tagline: "Asesoría patrimonial, precisión suiza.",
    login: "Acceder", logout: "Salir", email: "Email", password: "Contraseña",
    sign_in: "Entrar", dashboard: "Panel", clients: "Clientes",
    calendar: "Kalender", notifications: "Notificaciones", settings: "Ajustes",
    add_client: "Nuevo Kunde", add_client_ai: "Kunde con IA",
    search_clients: "Buscar clientes…", no_clients: "Sin clientes.",
    first_name: "Nombre", last_name: "Apellido", date_of_birth: "Fecha nac.",
    place_of_birth: "Lugar nac.", nationality: "Nacionalidad",
    document_number: "N° Doc.", address: "Dirección", city: "Ciudad",
    postal_code: "CP", canton: "Cantón", country: "País", phone: "Teléfono",
    notes: "Notas", save: "Guardar", cancel: "Cancelar", delete: "Eliminar",
    edit: "Editar", upload: "Subir", upload_doc: "Subir documento",
    upload_policy: "Subir Póliza", ai_extract: "Extraer con IA",
    ai_provider: "Modelo IA", documents: "Documentos", policies: "Pólizas",
    insurances: "Seguros", insurance_status: "Estado seguros",
    expiring_soon: "Por vencer (60d)", total_clients: "Clientes totales",
    total_policies: "Pólizas totales", unread_notifs: "Sin leer",
    company: "Compañía", policy_number: "N° Póliza", start_date: "Inicio",
    end_date: "Vencimiento", premium: "Vorher", currency: "Moneda",
    insurance_type: "Typ", new_policy: "Nueva Póliza",
    drop_here: "Arrastra o haz clic", processing_ai: "IA analizando…",
    extraction_done: "Extracción completa", fill_review: "Revisa los datos",
    mark_all_read: "Marcar leídas", no_notifications: "Sin notificaciones",
    policy_expires_in: "Vence en", days: "días", profile: "Perfil",
    personal_docs: "Documentos personales", has_insurance: "Asegurado",
    no_insurance: "Sin seguro", welcome_back: "Bienvenido",
    language: "Idioma",
    services: "Servicios", companies: "Compañías", users: "Usuarios",
    financial_analysis: "Análisis Financiero", new_analysis: "Nuevo Análisis", ai_prefill: "Pre-rellenar con IA", fa_open: "Abrir Análisis Financiero",
    pillar_trust: "CONFIANZA", pillar_competence: "COMPETENCIA",
    pillar_independence: "INDEPENDENCIA", pillar_security: "SEGURIDAD",
    consultant: "Asesor", role: "Rol", admin: "Admin",
    assign: "Asignar", assigned_to: "Asignado a", unassigned: "Sin asignar",
    create_user: "Crear usuario", generate_pdf: "Exportar PDF",
    sign: "Firmar", signature: "Unterschrift", clear_signature: "Borrar",
    advisor1: "Asesor FINMA", advisor2: "Asesor sin FINMA",
    client_confirmation: "Confirmación cliente",
    form_tandem: "Modelo Tandem", form_beratungsprotokoll: "Acta asesoría",
    form_angemessenheitspruefung: "Verificación idoneidad", form_kuendigung: "Cancelación KVG/VVG",
    new_form: "Nuevo formulario", select_client: "Selecciona cliente",
    select_form_type: "Formulartyp", send_to_company: "Enviar documentos",
    no_companies: "Sin compañías", add_company: "Añadir compañía",
    months: ["Enero","Febrero","März","Abril","Mayo","Junio","Julio","August","Septiembre","Octubre","Noviembre","Diciembre"],
    weekdays_short: ["Lun","Mar","Mié","Jue","Vie","Sáb","Dom"],
    today: "Hoy", select_provider: "Selecciona modelo",
    select_doc_type: "Typ de documento", confirm_delete: "¿Eliminar?",
    yes_delete: "Sí, eliminar", select_client_first: "Selecciona un cliente",
    insurance_types: {
      casa: "Hogar", auto: "Auto", rc: "RC", tutela_legale: "Legal",
      malattia: "Salud", viaggi: "Viaje", negozio: "Comercio",
      vita_3a: "Pilar 3A", vita_3b: "Pilar 3B", hypothek: "Hipoteca", mietkaution: "Fianza alquiler",
    },
    personal_types: {
      profile_photo: "Foto de perfil",
      carta_identita: "DNI (Frente)", carta_identita_retro: "DNI (Reverso)", patente: "Licencia",
      permesso: "Permiso", passaporto: "Pasaporte",
      tandem_formular: "Modelo Tandem", beratungsprotokoll: "Acta asesoría",
      angemessenheitspruefung: "Verificación idoneidad", kuendigung: "Cancelación",
      analisi_finanziaria: "Análisis financiero",
    },
  },
  pt: {
    app_name: "Swiss Wealth CRM",
    tagline: "Consultoria patrimonial, precisão suíça.",
    login: "Entrar", logout: "Sair", email: "Email", password: "Senha",
    sign_in: "Entrar", dashboard: "Painel", clients: "Clientes",
    calendar: "Calendário", notifications: "Notificações", settings: "Ajustes",
    add_client: "Novo Kunde", add_client_ai: "Kunde com IA",
    search_clients: "Buscar clientes…", no_clients: "Sem clientes.",
    first_name: "Vorname", last_name: "Sobrenome", date_of_birth: "Nascimento",
    place_of_birth: "Local nasc.", nationality: "Nacionalidade",
    document_number: "Nº Doc.", address: "Endereço", city: "Cidade",
    permit_type: "Typ doc/autorização",
    postal_code: "CEP", canton: "Cantão", country: "País", phone: "Telefone",
    notes: "Notas", save: "Salvar", cancel: "Cancelar", delete: "Excluir",
    edit: "Editar", upload: "Enviar", upload_doc: "Enviar documento",
    upload_policy: "Enviar Apólice", ai_extract: "Extrair com IA",
    ai_provider: "Modelo IA", documents: "Documentos", policies: "Apólices",
    insurances: "Seguros", insurance_status: "Estado seguros",
    expiring_soon: "Vencendo (60d)", total_clients: "Clientes",
    total_policies: "Apólices", unread_notifs: "Não lidas",
    company: "Companhia", policy_number: "Nº Apólice", start_date: "Início",
    end_date: "Vencimento", premium: "Prêmio", currency: "Moeda",
    insurance_type: "Typ", new_policy: "Nova Apólice",
    drop_here: "Arraste ou clique", processing_ai: "IA analisando…",
    extraction_done: "Extração concluída", fill_review: "Revise os dados",
    mark_all_read: "Marcar lidas", no_notifications: "Sem notificações",
    policy_expires_in: "Vence em", days: "dias", profile: "Perfil",
    personal_docs: "Documentos pessoais", has_insurance: "Segurado",
    no_insurance: "Sem seguro", welcome_back: "Bem-vindo",
    language: "Idioma",
    services: "Serviços", companies: "Companhias", users: "Utilizadores",
    financial_analysis: "Análise Financeira", new_analysis: "Nova Análise", ai_prefill: "Pré-preenchimento IA", fa_open: "Abrir Análise Financeira",
    pillar_trust: "CONFIANÇA", pillar_competence: "COMPETÊNCIA",
    pillar_independence: "INDEPENDÊNCIA", pillar_security: "SEGURANÇA",
    consultant: "Consultor", role: "Função", admin: "Admin",
    assign: "Atribuir", assigned_to: "Atribuído a", unassigned: "Sem atribuição",
    create_user: "Criar utilizador", generate_pdf: "Exportar PDF",
    sign: "Assinar", signature: "Assinatura", clear_signature: "Limpar",
    advisor1: "Consultor FINMA", advisor2: "Consultor sem FINMA",
    client_confirmation: "Confirmação cliente",
    form_tandem: "Modelo Tandem", form_beratungsprotokoll: "Ata consultoria",
    form_angemessenheitspruefung: "Verificação adequação", form_kuendigung: "Cancelamento KVG/VVG",
    new_form: "Novo formulário", select_client: "Selecione cliente",
    select_form_type: "Typ formulário", send_to_company: "Enviar documentos",
    no_companies: "Sem companhias", add_company: "Adicionar companhia",
    months: ["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","August","Setembro","Outubro","Novembro","Dezembro"],
    weekdays_short: ["Seg","Ter","Qua","Qui","Sex","Sáb","Dom"],
    today: "Hoje", select_provider: "Selecione modelo",
    select_doc_type: "Typ de documento", confirm_delete: "Confirmar exclusão?",
    yes_delete: "Sim, excluir", select_client_first: "Selecione um cliente",
    insurance_types: {
      casa: "Casa", auto: "Auto", rc: "RC", tutela_legale: "Jurídico",
      malattia: "Saúde", viaggi: "Viagem", negozio: "Comércio",
      vita_3a: "Pilar 3A", vita_3b: "Pilar 3B", hypothek: "Hipoteca", mietkaution: "Caução aluguer",
    },
    personal_types: {
      profile_photo: "Foto de perfil",
      carta_identita: "Identidade (Frente)", carta_identita_retro: "Identidade (Verso)", patente: "Habilitação",
      permesso: "Autorização", passaporto: "Passaporte",
      tandem_formular: "Modelo Tandem", beratungsprotokoll: "Ata consultoria",
      angemessenheitspruefung: "Verificação adequação", kuendigung: "Cancelamento",
      analisi_finanziaria: "Análise financeira",
    },
  },
};

export const INSURANCE_TYPES = ["casa", "auto", "rc", "tutela_legale", "malattia", "viaggi", "negozio", "vita_3a", "vita_3b", "hypothek", "mietkaution"];
export const PERSONAL_DOC_TYPES = ["carta_identita", "carta_identita_retro", "patente", "tandem_formular", "beratungsprotokoll", "analisi_finanziaria"];

export const SWISS_INSURERS = [
  "AXA", "Zurich", "Helvetia", "Allianz Suisse", "Swiss Life",
  "Generali", "La Mobiliare", "Vaudoise", "Baloise", "CSS",
  "Sanitas", "Visana", "Concordia", "Groupe Mutuel", "Swisscare",
];

export function getDict(code) {
  return dict[code] || dict.it;
}
